import $ from 'jquery'
import 'chosen-js'

function isVisible(target) {
    let result = false
    // Все позиции элемента
    let targetPosition = {
            top: window.pageYOffset + target.getBoundingClientRect().top,
            left: window.pageXOffset + target.getBoundingClientRect().left,
            right: window.pageXOffset + target.getBoundingClientRect().right,
            bottom: window.pageYOffset + target.getBoundingClientRect().bottom
        },
        // Получаем позиции окна
        windowPosition = {
            top: window.pageYOffset,
            left: window.pageXOffset,
            right: window.pageXOffset + document.documentElement.clientWidth,
            bottom: window.pageYOffset + document.documentElement.clientHeight
        }

    if (targetPosition.bottom > windowPosition.top && // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
        targetPosition.top < windowPosition.bottom && // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
        targetPosition.right > windowPosition.left && // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
        targetPosition.left < windowPosition.right) { // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
        // Если элемент полностью видно, то запускаем следующий код
        result = true
    }
    return result
}

const chosenOptions = {
    disable_search_threshold: 10,
    no_results_text: 'Упс, ничего не найдено!',
    placeholder_text: '~',
    width: '100%',
    allow_single_deselect: true,
    search_contains: true,
    enable_split_word_search: false,
}


const chosenOptionsSearchContains = {
    disable_search_threshold: 10,
    no_results_text: 'Упс, ничего не найдено!',
    placeholder_text: '~',
    width: '100%',
    allow_single_deselect: true,
    search_contains: false,
    enable_split_word_search: false,
}

let options = {
    threshold: [0.5],
}

function initChosenSelect(elements) {
    elements.forEach((change) => {
        let elem = change.target
        if (change.isIntersecting) {
            if (!$(elem).hasClass('js-chosen-inited')) {
                let chosenInstance = $(elem).addClass('js-chosen-inited').chosen('destroy').chosen(chosenOptions)
                $(elem).each(function (i, v) {
                    v.chosen = chosenInstance;
                });
            }
        }
    })
}

function initChosenStrictSelect(elements) {
    elements.forEach((change) => {
        let elem = change.target
        if (change.isIntersecting) {
            if (!$(elem).hasClass('js-chosen-select-strict-inited')) {
                let chosenInstance = $(elem).addClass('js-chosen-select-strict-inited').chosen('destroy').chosen(chosenOptionsSearchContains)
                $(elem).each(function (i, v) {
                    v.chosen = chosenInstance;
                });
            }
        }
    })
}


let observerChosen = new IntersectionObserver(initChosenSelect, options)
let observerChosenStrict = new IntersectionObserver(initChosenStrictSelect, options)


let chosenRebuild = function () {
    let elements = $('select.chosen-select')
    elements.each(function (i, elem) {
        observerChosen.observe(elem)
    })

    elements = $('select.chosen-select-strict');
    elements.each(function (i, elem) {
        observerChosenStrict.observe(elem)
    })
}

chosenRebuild();










